/* eslint-disable camelcase */

import React from 'react';
import GoogleMapReact from 'google-map-react';

import useIntersectionObserver from 'hooks/useIntersectionObserver';

import Mark from '../Mark';

const StoreMap = ({ tradingPoints, handleMapObject }) => {
  const [targetRef, isVisible] = useIntersectionObserver();
  const apiKey = process.env.GATSBY_GOOGLE_MAPS_API_KEY;
  const defaultProps = {
    center: {
      lat: 4.675612127947397,
      lng: -74.0467914684936,
    },
    zoom: 11,
  };

  const handleApiLoaded = (map, maps) => {
    handleMapObject([map, maps]);
  };

  return (
    <div className="google-map" ref={targetRef}>
      {isVisible && (
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
        >
          {tradingPoints.map(({ marker, contentful_id }) => (
            <Mark key={contentful_id} lat={marker?.lat} lng={marker?.lon} />
          ))}
        </GoogleMapReact>
      )}
    </div>
  );
};

export default StoreMap;
